"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseAdapter = void 0;
var ResponseAdapter = /** @class */ (function () {
    function ResponseAdapter(jsonResponse, getResponse) {
        this.jsonResponse = jsonResponse;
        this.getResponse = getResponse;
    }
    Object.defineProperty(ResponseAdapter.prototype, "result", {
        get: function () {
            return this.getResponse();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResponseAdapter.prototype, "raw", {
        get: function () {
            return this.jsonResponse;
        },
        enumerable: false,
        configurable: true
    });
    ResponseAdapter.prototype.toJSON = function () {
        return this.jsonResponse;
    };
    return ResponseAdapter;
}());
exports.ResponseAdapter = ResponseAdapter;
//# sourceMappingURL=ResponseAdapter.js.map